import {
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "ui/components/sidebar";
import { Link, useLocation } from "react-router-dom";
import { usePermissions } from "contexts/permission";

export function NavSubItem({
  title,
  url,
  requiredPermissions,
  className = "",
  ...props
}) {
  const permissions = usePermissions();
  const location = useLocation();

  // Check if the current path starts with the URL to determine active state
  const isActive = url ? location.pathname.startsWith(`${url}`) : false;

  // If user is admin, bypass permission checks
  // if (requiredPermissions && !(permissions.isAdmin && permissions.isAdmin())) {
  if (!permissions.evaluatePermission(requiredPermissions)) {
    return null;
  }
  // }

  return (
    <SidebarMenuSubItem>
      <SidebarMenuSubButton
        asChild
        className={className}
        data-active={isActive}
        {...props}
      >
        <Link to={url}>
          <span>{title}</span>
        </Link>
      </SidebarMenuSubButton>
    </SidebarMenuSubItem>
  );
}
